import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import {
  AuthPrimaryButton,
  AuthSecondaryButton,
} from '../components/auth-button';
import { useStyles } from './CompleteRegistration.styles';
import { RegistrationWizardStep } from './complete-registration.types';

interface IRegistrationWizardActionsProps {
  step: RegistrationWizardStep;
  isSaving: boolean;
  onBack: () => void;
  onNext: () => void;
  onSkipSetup: () => void;
  onSave: () => void;
}

export default function RegistrationWizardActions({
  step,
  isSaving,
  onBack,
  onNext,
  onSkipSetup,
  onSave,
}: IRegistrationWizardActionsProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);

  if (step === RegistrationWizardStep.name) {
    return (
      <div className={classes.actionsRow}>
        <AuthPrimaryButton
          fullWidth
          loader={isSaving}
          onClick={onNext}
          type="button">
          {t('signUp.completeRegistration.next')}
        </AuthPrimaryButton>
      </div>
    );
  }

  if (step === RegistrationWizardStep.measurements) {
    return (
      <div className={classes.actionsRow}>
        <AuthSecondaryButton
          fullWidth
          disabled={isSaving}
          onClick={onBack}
          type="button">
          {t('signUp.completeRegistration.back')}
        </AuthSecondaryButton>
        <AuthSecondaryButton
          fullWidth
          disabled={isSaving}
          onClick={onSkipSetup}
          type="button">
          {t('signUp.completeRegistration.skipSetup')}
        </AuthSecondaryButton>
        <AuthPrimaryButton
          fullWidth
          loader={isSaving}
          onClick={onNext}
          type="button">
          {t('signUp.completeRegistration.next')}
        </AuthPrimaryButton>
      </div>
    );
  }

  if (step === RegistrationWizardStep.privacy) {
    return (
      <div className={classes.actionsRow}>
        <AuthSecondaryButton
          fullWidth
          disabled={isSaving}
          onClick={onBack}
          type="button">
          {t('signUp.completeRegistration.back')}
        </AuthSecondaryButton>
        <AuthPrimaryButton
          fullWidth
          loader={isSaving}
          onClick={onSave}
          type="button">
          {t('signUp.completeRegistration.save')}
        </AuthPrimaryButton>
      </div>
    );
  }

  return (
    <div className={classes.actionsRow}>
      <AuthSecondaryButton
        fullWidth
        disabled={isSaving}
        onClick={onBack}
        type="button">
        {t('signUp.completeRegistration.back')}
      </AuthSecondaryButton>
      <AuthPrimaryButton
        fullWidth
        loader={isSaving}
        onClick={onNext}
        type="button">
        {t('signUp.completeRegistration.next')}
      </AuthPrimaryButton>
    </div>
  );
}
